// NCUA Potential Member Survey — mandatory attachment to Form 9500 charter application.
// Transcribed verbatim from the user-uploaded NCUA_Potential_Member_Survey.pdf.
// Single source of truth consumed by /credit-union pledge form + admin dashboard.

export const SURVEY_DISCLAIMER =
  "Your responses are strictly confidential and will be utilized solely to demonstrate the economic justification and market demand for a new community-chartered Federal Credit Union to the National Credit Union Administration (NCUA).";

export const SURVEY_QUESTIONS = [
  {
    key: "fom_relationship",
    type: "checkbox",
    number: 1,
    label:
      "What is your relationship to our Well-Defined Local Community footprint? (Check all that apply)",
    options: [
      "I live in Fulton County / DeKalb County / City of Atlanta / College Park",
      "I work in Fulton County / DeKalb County / City of Atlanta / College Park",
      "I worship in Fulton County / DeKalb County / City of Atlanta / College Park",
      "I attend school in Fulton County / DeKalb County / City of Atlanta / College Park",
    ],
    minSelected: 1,
  },
  {
    key: "current_bank",
    type: "radio",
    number: 2,
    label: "Where do you currently conduct the majority of your financial transactions?",
    options: [
      "Traditional Commercial Bank (e.g., Chase, Bank of America, Wells Fargo)",
      "Existing Credit Union",
      "Alternative Provider (Check-cashing store, payday lender, digital wallet only)",
      "Unbanked (Do not currently use a financial institution)",
    ],
  },
  {
    key: "join_likelihood",
    type: "radio",
    number: 3,
    label:
      "If a community-focused, member-owned Federal Credit Union were established in your neighborhood, how likely are you to move your accounts or join?",
    options: ["Very Likely", "Somewhat Likely", "Neutral / Unsure"],
  },
  {
    key: "primary_reason",
    type: "radio",
    number: 4,
    label: "What is the primary reason you would join TDSOP Federal Credit Union?",
    options: [
      "Lower loan interest rates than commercial banks",
      "Higher dividend yields on savings and certificate accounts",
      "Lower / fewer transaction fees",
      "Mission-driven investment back into the local community",
    ],
  },
  {
    key: "deposit_accounts",
    type: "checkbox",
    number: 5,
    label:
      "If you become a member, what type of DEPOSIT accounts would you establish? (Check all that apply)",
    options: [
      "Regular Share Savings Account",
      "Share Draft Checking Account",
      "Direct Deposit (Payroll, Social Security, or Retirement)",
      "Share Certificates (CDs) / Individual Retirement Accounts (IRAs)",
    ],
    minSelected: 1,
  },
  {
    key: "deposit_balance",
    type: "radio",
    number: 6,
    label:
      "On average, what total balance do you anticipate maintaining across your TDSOP deposit accounts within the first 12 months?",
    options: [
      "$1 to $499",
      "$500 to $1,499",
      "$1,500 to $4,999",
      "$5,000 to $9,999",
      "$10,000 or more",
    ],
  },
  {
    key: "loan_products",
    type: "checkbox",
    number: 7,
    label:
      "What types of LOAN products do you anticipate needing from the credit union over the next 36 months? (Check all that apply)",
    options: [
      "Used or New Auto Loans",
      "Unsecured Personal Loans / Lines of Credit",
      "Small Business / Micro-Enterprise Loans",
      "Credit Builder Loans",
      "Mortgage or Home Equity Products",
    ],
    minSelected: 1,
  },
  {
    key: "loan_balance",
    type: "radio",
    number: 8,
    label:
      "If you were to apply for an auto or personal loan with us tomorrow, what estimated loan balance would you require?",
    options: [
      "Under $2,500",
      "$2,500 to $9,999",
      "$10,000 to $24,999",
      "$25,000 to $49,999",
      "$50,000 or more",
    ],
  },
  {
    key: "delivery_channels",
    type: "checkbox",
    number: 9,
    label:
      "Which delivery channels are essential for you to utilize our services effectively? (Check all that apply)",
    options: [
      "Advanced Mobile Banking App (Mobile Check Deposit, Transfer Tools)",
      "Secure Online / Desktop Web Portal",
      "Surcharge-Free Local ATM Network Access",
      "Physical Branch Location / Shared Branching Kiosk",
    ],
    minSelected: 1,
  },
  {
    key: "bank_satisfaction",
    type: "radio",
    number: 10,
    label:
      "Do you currently feel that traditional commercial banks adequately serve the unique economic needs of families and businesses in the Atlanta metropolitan area?",
    options: ["Yes, adequately served", "Neutral", "No, inadequately served"],
  },
];
